
String.prototype.escapeRegex = function (value) {
    return this.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

String.prototype.containRegex = function (str) {
    var matcher = new RegExp(str, "i");
    return matcher.test(this);
    //''.indexOf.call(this, str, startIndex) !== -1;
};